import React from 'react';
import PartnersList from 'components/partners-list';
import europeanCommissionLogo from './european-commission.svg';
import './style.css';

const Footer = () => (
  <footer className="aq-footer">
    <div className="container">
      <div className="linear-separation" />
      <div className="row">
        <div className="col-sm col-md-6">
          <h2>Partners</h2>
          <PartnersList onlyLogos />
        </div>
        <div className="col-sm col-md-3 offset-md-3 d-flex align-items-end">
          <div className="footer-right">
            <div className="footer-funding">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://ec.europa.eu/"
              >
                <img src={europeanCommissionLogo} alt="european commission" />
              </a>
              <p>This project has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement No 776361</p>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="footer-twitter">
          <a
            aria-hidden="true"
            href="https://twitter.com/AirQast"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="footer-twitter-text">Follow us on twitter</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/app/footer/index.js